/* eslint-disable global-require */
import Vue from 'vue';

export function refreshToken(store) {
  if (store.state.auth.auth.refreshingState) {
    return store.state.auth.auth.refreshingCall;
  }
  store.commit('auth/setRefreshingState', true);
  const refreshingCall = Vue.axios
    .post(`${Vue.axios.defaults.baseURL}auth/refresh`, {
      refreshToken: localStorage.getItem('refresh_token')
    })
    .then((res) => {
      const Auth = require('./auth').default;
      localStorage.setItem(Auth.options.tokenDefaultName, res.data.token);
      localStorage.setItem('refresh_token', res.data.refreshToken);
      Vue.axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
      store.commit('auth/setRefreshingState', false);
      store.commit('auth/setRefreshingCall', undefined);
      store.commit('auth/setLastRefreshSuccess', true);
      return Promise.resolve(true);
    })
    .catch((err) => {
      store.commit('auth/setRefreshingState', false);
      store.commit('auth/setRefreshingCall', undefined);
      store.commit('auth/setLastRefreshSuccess', false);
      return Promise.reject(err);
    });
  store.commit('auth/setRefreshingCall', refreshingCall);
  return refreshingCall;
}

export function isAuthorized(Auth, to) {
  let isAuth = true;
  let next = to.name;
  for (let i = 0; i < to.matched.length; i += 1) {
    const auth = Auth.options.authMeta && to.matched[i].meta[Auth.options.authMeta];
    if (Array.isArray(auth)) {
      isAuth = Auth.storeManager.check(auth);
    } else {
      isAuth = true;
    }
    if (!isAuth) {
      next = to.matched[i].meta.redirectOnAuthFail;
      break;
    }
  }
  return { success: isAuth, next };
}
